//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useListableProperties } from '@/api/legacy/useListableProperties';
import DpPopulatedSelect from '../select/PopulatedSelect.vue';

export default {
  name: 'DpMultiplePropertySelect',
  components: {
    DpPopulatedSelect,
  },
  props: {
    value: { type: Array, default: () => [] },
    title: { type: String, default: '' },
    hideId: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    tooltip: { type: String, default: null },
    disableOnlineProperties: { type: Boolean, default: false },
  },
  setup() {
    const { listableProperties } = useListableProperties();
    return { listableProperties };
  },
  data() {
    return {
      currProperty: null,
      selectedProperties: [],
    };
  },
  computed: {
    computedTitle() {
      if (!this.title) {
        return 'Select multiple properties';
      }
      return this.title;
    },
    hiddenProperties() {
      // FIXME: do this at store level.
      let hidden = this.selectedProperties.filter((p) => p !== null);
      if (this.hideId) {
        hidden = hidden.concat(this.listableProperties[0]);
      }
      return hidden;
    },
    visibleSelectProperties() {
      return this.selectedProperties.filter((p) => !p.hidden);
    },
  },
  watch: {
    value(newValue) {
      this.updateFromValue(newValue);
    },
  },
  mounted() {
    this.updateFromValue(this.value);
  },
  methods: {
    handleAddProperty(prop) {
      if (!prop) return;

      const existingProperties = this.selectedProperties.filter((p) => p.name === prop.name);
      if (existingProperties.length > 0) {
        return;
      }
      this.selectedProperties.push(prop);
      this.pushChanges();

      this.$nextTick(() => {
        this.currProperty = null;
      });
    },
    handleRemoveProperty(prop) {
      if (!prop) return;
      this.selectedProperties = this.selectedProperties.filter((p) => p.name !== prop.name);
      this.pushChanges();
    },
    pushChanges() {
      this.$emit('input', this.selectedProperties);
      this.$emit('change', this.selectedProperties);
    },
    updateFromValue(value) {
      this.selectedProperties = value.filter((p) => p !== null);
    },
  },
};
